import * as jQuery from 'jquery';
import * as moment from 'moment';
import * as _ from 'underscore';

import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NguCarousel, NguCarouselConfig, NguCarouselStore } from '@ngu/carousel';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import {
	CampaignsUniqueReachFrequency,
	CampaignGraphData
} from '../../../analytics-core/interfaces/unique-reach-frequency.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { UtilityService } from '../../../../core/utility/services/utility.service';

@Component({
	selector: 'app-unique-reach-and-frequency',
	styleUrls: ['./unique-reach-and-frequency.component.css'],
	templateUrl: './unique-reach-and-frequency.component.html'
})
export class UniqueReachAndFrequencyComponent extends BaseWidgetComponent implements OnInit {
	@Input() downloadconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() customchartconfiguration: any;
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() sectionclass: string;
	@Input() seriesviewconfiguration: any;
	@Input() nodatamessage: any;
	@ViewChild('carousel') carousel: NguCarousel<any>;
	public selectedRadioButtonId: number;
	public currentIndex = 0;
	public displayIndex = 0;
	public showLoad = true;
	public hasData = true;
	public showToggleArrow: boolean = false;
	public downloadConfiguration: DownloadConfig;
	public carouselOne: NguCarouselConfig;
	public downloadCSVColumns: any;
	public isR104: boolean = false;
	public plotOptions = {
		series: {
			events: {
				legendItemClick(event: any): any {
					if (event.target.visible) {
						this.legendItem.attr({
							opacity: 0.5
						});
					} else {
						this.legendItem.attr({
							opacity: 1
						});
					}
				}
			},
			states: {
				inactive: {
					opacity: 1
				}
			}
		}
	};
	public toolTipFormatter = {
		formatter(): any {
			const yVal = this.series.name.toLowerCase().includes('uniques')
				? this.point.y.toLocaleString()
				: this.point.y.toLocaleString() + 'x';
			return `<div class="toolTipClass ${this.series.name}">
									<table>
										<tr class="tooltipRow" style="color: ${this.color} !important"><td class="tooltipDate tooltipRow">
											<b>${this.x}</b></td></tr>
										<tr><td class="tooltipRow"><b>${yVal} </b></td></tr>
										<tr><td class="tooltipRow"><b>${this.series.name.trim().split(' ')[0]}</b></td></tr>
									</table>
						</div>`;
		}
	};
	public campaignsList = [];
	public reflowTimeout: any;
	public frequencyLegendIcon: any = '';
	public campaignCarouselItem: any;
	public dateFormatter: string = 'MM/DD';
	public getSeriesOptions = [
		{
			borderRadiusBottomLeft: '50%',
			borderRadiusBottomRight: '50%',
			borderRadiusTopLeft: '50%',
			borderRadiusTopRight: '50%',
			dataSource: 'uniques',
			index: 0,
			marker: {
				symbol: 'circle'
			},
			name: 'Uniques (trailing 30-day)',
			type: 'column',
			yAxis: 0,
			tooltipText:
				'The number of unique households exposed to the ad at least once in the past 30 days (a rolling 30 day window).'
		},
		{
			dataSource: 'frequency',
			index: 1,
			marker: {
				fillColor: '#FFFFFF',
				lineColor: null,
				lineWidth: 1,
				symbol: 'circle'
			},
			name: 'Frequency (trailing 30-day)',
			type: 'line',
			yAxis: 1,
			tooltipText:
				'The average number of times a unique household has seen the ad in the past 30 days (a rolling 30 day window).'
		}
	];
	public frequencyLegendTooltip: string;
	public uniquesLegendTooltip: string;
	protected colorPalette: ColorPalette;
	protected carouselToken: string;
	maxLabelsAllowed: number;
	public showDateRangeBanner = false;
	public minDate: moment.Moment;

	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel
	) {
		super(analyticsService);
		this.minDate = moment().subtract(2, 'years').subtract(3, 'months').startOf('day');
		EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			if (this.carousel && this.carousel.reset) {
				this.carousel.reset();
			}
		});
		this.carouselOne = {
			grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
			loop: true,
			point: {
				visible: true
			},
			touch: true,
			velocity: 0.2
		};
	}

	ngOnInit(): void {
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.customchartconfiguration = JSON.parse(decodeURI(this.customchartconfiguration));
		this.customchartconfiguration.graphConfig.plotOptions = {
			...this.customchartconfiguration.graphConfig.plotOptions,
			...this.plotOptions
		};
		this.seriesviewconfiguration = this.customchartconfiguration.seriesViewConfiguration;
		this.selectedRadioButtonId = this.customchartconfiguration?.seriesViewConfiguration?.defaultRadioButtonSelected
			? this.customchartconfiguration.seriesViewConfiguration.defaultRadioButtonSelected
			: 0;

		this.customchartconfiguration.graphConfig.tooltip = {
			...this.customchartconfiguration.graphConfig.tooltip,
			...this.toolTipFormatter
		};
		this.maxLabelsAllowed = this.customchartconfiguration.graphConfig?.xAxis?.labels?.maxLabelsAllowed
			? this.customchartconfiguration.graphConfig.xAxis.labels.maxLabelsAllowed
			: 1;
		this.getSeriesOptions = this.customchartconfiguration.graphConfig?.seriesOptions
			? this.customchartconfiguration.graphConfig.seriesOptions
			: this.getSeriesOptions;
		this.frequencyLegendIcon = this.customchartconfiguration.graphConfig?.legendLayout?.legendIconFrequency
			? this.customchartconfiguration.graphConfig.legendLayout.legendIconFrequency
			: this.frequencyLegendIcon;
		this.dateFormatter = this.customchartconfiguration.graphConfig.xAxis?.labels?.dateFormatter
			? this.customchartconfiguration.graphConfig.xAxis.labels.dateFormatter
			: this.dateFormatter;
		this.getSeriesOptions.forEach((item) => {
			if (item.name.toUpperCase().includes('UNIQUES')) {
				this.uniquesLegendTooltip = item.tooltipText;
			} else {
				this.frequencyLegendTooltip = item.tooltipText;
			}
		});
		super.ngOnInit();
		this.nodatamessage =
			UtilityService.isUndefinedOrNull(this.nodatamessage) ||
			this.nodatamessage === 'null' ||
			this.nodatamessage === 'undefined'
				? 'No Data Available, Select Different Date Range'
				: this.nodatamessage;
	}

	resetToDefaults(): void {
		this.showLoad = true;
		this.hasData = false;
		this.campaignCarouselItem = {};
		this.currentIndex = 0;
		this.displayIndex = 0;
		this.showToggleArrow = false;
		this.campaignsList = [];
	}

	setReflowTimeout(): void {
		this.reflowTimeout = setInterval(() => {
			const chartWidth = Number(jQuery('.individual-chart .highcharts-root').width());
			const chartContainerWidth = Number(jQuery('.chartElement').width());
			if (chartWidth && chartContainerWidth && chartWidth < chartContainerWidth) {
				clearInterval(this.reflowTimeout);
				EmitterService.get(EVENT_EMITTERS.CAROUSEL_CHART_REDRAW).emit(true);
			}
		}, 2000);
	}

	requestData(): void {
		this.resetToDefaults();
		if (this.requestSubscription) {
			this.requestSubscription.unsubscribe();
		}

		this.requestSubscription = this.analyticsService
			.processCustomServiceRequest(this.key)
			.subscribe((response: any) => {
				this.showToggleArrow = false;
				if (response.success && response.data.length > 0) {
					const responseData = response.data;
					this.hasData = true;
					this.processCampaignResponseData(responseData);
				} else {
					this.showLoad = false;
					this.hasData = false;
				}
			});
	}

	processCampaignResponseData(responseData: any): void {
		const uniqReachFreqDataGroupByCampaigns: any = _.groupBy(responseData, 'campaign_name');
		for (const [campaignDatesdata] of Object.entries(uniqReachFreqDataGroupByCampaigns)) {
			const averageValuesForCampaigns = _.filter(uniqReachFreqDataGroupByCampaigns[campaignDatesdata], (obj: any) => {
				return Number(obj.average_values) === 1;
			});
			const datesDataForCampaigns = _.filter(uniqReachFreqDataGroupByCampaigns[campaignDatesdata], (obj: any) => {
				return Number(obj.average_values) === 0;
			});
			const campaignObj: CampaignsUniqueReachFrequency = {} as CampaignsUniqueReachFrequency;
			const allDatesDataForCampaign: CampaignGraphData[] = [];
			for (const campaign of datesDataForCampaigns) {
				const campaignDetails: CampaignGraphData = {} as CampaignGraphData;
				campaignDetails.date = campaign.date ? campaign.date : null;
				campaignDetails.houseHoldFrequency = campaign.frequency_per_household ? campaign.frequency_per_household : null;
				campaignDetails.houseHoldUnique = campaign.household_unique ? campaign.household_unique : null;
				campaignDetails.impressions = campaignDetails.impressions ? campaignDetails.impressions : null;
				allDatesDataForCampaign.push(campaignDetails);
			}
			campaignObj.name = campaignDatesdata;
			campaignObj.data = allDatesDataForCampaign;
			campaignObj.averageLifetimes =
				averageValuesForCampaigns.length > 0 ? this.getLiftimeAverages(averageValuesForCampaigns[0]) : [];
			campaignObj.showBanner =
				averageValuesForCampaigns.length > 0 ? this.checkCampaignDateBanner(averageValuesForCampaigns[0]) : false;
			this.campaignsList.push(campaignObj);
		}
		this.sortCampaignsAsLatestFisrt(this.campaignsList);
		this.processGraphConfigData(this.campaignsList);
	}

	processGraphConfigData(responseList: any[]): any {
		this.campaignsList = [];
		responseList.forEach((campaignItem, index) => {
			const household_uniques = [];
			const household_frequency = [];
			const categories = [];

			campaignItem.data.forEach((dataObj) => {
				campaignItem.showChart =
					!campaignItem.showChart && (Number(dataObj.houseHoldFrequency) > 0 || Number(dataObj.houseHoldUnique) > 0)
						? true
						: campaignItem.showChart;
				household_frequency.push(Number(dataObj.houseHoldFrequency));
				household_uniques.push(Number(dataObj.houseHoldUnique));
				categories.push(moment(dataObj.date).format(this.dateFormatter));
			});
			// merge the camapaign data with chartconfig from config file
			const campaignItemGraphConfig = {
				...{},
				...this.customchartconfiguration.graphConfig,
				...campaignItem
			};
			campaignItemGraphConfig.xAxis.labels.step =
				campaignItemGraphConfig.data.length > 0 &&
				this.maxLabelsAllowed > 1 &&
				campaignItemGraphConfig.data.length > this.maxLabelsAllowed &&
				Math.ceil(campaignItemGraphConfig.data.length / this.maxLabelsAllowed) > 1
					? Math.ceil(campaignItemGraphConfig.data.length / this.maxLabelsAllowed)
					: campaignItemGraphConfig?.xAxis?.labels?.step
					? campaignItemGraphConfig.xAxis.labels.step
					: 1;
			const campaignItemWithYaxis = this.getYaxisConfigForEachCampaign(campaignItemGraphConfig, household_frequency);
			campaignItemWithYaxis.xAxis = this.getXaxisConfigForEachCampaign(categories);
			const householdObj = {
				frequency: household_frequency,
				uniques: household_uniques
			};
			campaignItemWithYaxis.graphData = this.getGraphDataforEachCampaign(householdObj);
			campaignItemWithYaxis.legendLayout = this.getLegendConfigforEachCampaign(
				campaignItemWithYaxis,
				this.frequencyLegendIcon,
				this.frequencyLegendTooltip,
				this.uniquesLegendTooltip
			);
			this.campaignsList.push(campaignItemWithYaxis);
		});
		const chartRedrawing = setInterval(() => {
			if (this.campaignsList.length === responseList.length) {
				setTimeout(() => {
					EmitterService.get(EVENT_EMITTERS.CAROUSEL_CHART_REDRAW).emit(true);
					this.showLoad = false;
				}, 2000);
				this.setReflowTimeout();
				this.campaignCarouselItem = this.campaignsList[this.currentIndex];
				this.campaignCarouselItem.xAxis.labels.step =
					this.campaignCarouselItem.data.length > 0 &&
					this.maxLabelsAllowed > 1 &&
					this.campaignCarouselItem.data.length > this.maxLabelsAllowed &&
					Math.ceil(this.campaignCarouselItem.data.length / this.maxLabelsAllowed) > 1
						? Math.ceil(this.campaignCarouselItem.data.length / this.maxLabelsAllowed)
						: this.campaignCarouselItem?.xAxis?.labels?.step
						? this.campaignCarouselItem.xAxis.labels.step
						: 1;
				this.showToggleArrow = this.campaignsList.length > 1;
				clearInterval(chartRedrawing);
			}
		}, 1);
	}

	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}

	getLiftimeAverages(campaignObject: any): any[] {
		return [
			{
				isNonZeroValue: !(campaignObject.monthly_avg_lifetime_unique > 0),
				parameterName: 'Uniques',
				parameterValue:
					campaignObject.monthly_avg_lifetime_unique > 0
						? // tslint:disable-next-line:radix indent
						  this.formatValuesForComma(parseInt(campaignObject.monthly_avg_lifetime_unique))
						: '--'
			},
			{
				isNonZeroValue: !(campaignObject.monthly_avg_lifetime_frequency > 0),
				parameterName: 'Frequency',
				parameterValue: this.isR104
					? campaignObject.monthly_avg_lifetime_frequency > 0
						? `${parseFloat(campaignObject.monthly_avg_lifetime_frequency.toString()).toString()}x`
						: '--'
					: campaignObject.monthly_avg_lifetime_frequency > 0
					? `${campaignObject.monthly_avg_lifetime_frequency}x`
					: '--'
			}
		];
	}

	getXaxisConfigForEachCampaign(categories: any[]): {} {
		this.customchartconfiguration.graphConfig.xAxis.labels = {
			...this.customchartconfiguration.graphConfig.xAxis.labels,
			...{
				formatter(): any {
					return `<span class='xlabel'> ${this.value} </span>`;
				}
			}
		};

		return {
			...this.customchartconfiguration.graphConfig.xAxis,
			...{ categories }
		};
	}

	getYaxisConfigForEachCampaign(campaign: any, household_frequency: any): any {
		campaign.yAxis = {
			labels: {
				useHTML: true,
				formatter(): any {
					return `<span class='xlabel'> ${this.value} </span>`;
				}
			}
		};
		campaign.yAxisPrimaryTitle = {
			...{},
			...campaign.yAxisPrimaryTitle,
			...{
				max: Math.max(...household_frequency) < 99 ? Math.max(...household_frequency) + 20 : 99,
				text: "<span class='xlabel yPrimaryTitle'>Frequency (trailing 30-day) </span>"
			}
		};
		campaign.yAxisSecondaryTitle = {
			...{},
			...campaign.yAxisSecondaryTitle,
			...{
				text: "<span class='xlabel ySecondaryTitle'> Uniques (trailing 30-day) </span>"
			}
		};
		campaign.yAxisPrimary['labels'] = {
			...campaign.yAxisPrimary['labels'],
			...{
				formatter(): string {
					return `<span class='xlabel yPrimaryLabel'> ${this.value} </span>`;
				}
			}
		};
		campaign.yAxisSecondary['labels'] = {
			...campaign.yAxisSecondary['labels'],
			...{
				formatter(): string {
					return `<span class='xlabel ySecondaryLabel'> ${this.value.toLocaleString()} </span>`;
				}
			}
		};
		return campaign;
	}

	getLegendConfigforEachCampaign(
		campaign: any,
		frequencyLegendIcon: any,
		frequencyLegendTooltip: string,
		uniquesLegendTooltip: string
	): {} {
		return {
			...campaign.legendLayout,
			...{
				labelFormatter(): any {
					if (this.name.toUpperCase().includes('FREQUENCY')) {
						if (frequencyLegendIcon !== '') {
							return `
									<img class="legend-icons ${this.name}" src="${frequencyLegendIcon}" width='23' height='23'>
									<span style='margin-left: 10px; position:relative; top:-6px;' class='xlabel ${this.name}'>
										${this.name}
									</span>
									<div class='legendTooltip-container'>
									<div class="tooltipText">${frequencyLegendTooltip}</div>
									<div class="tooltip-pointer"></div>
									</div>`;
						} else {
							return `
									<i class="fa fa-circle secondary-color legend-icons ${this.name}" style="font-size: 29px"></i>
									<span style='margin-left: 10px; position:relative; top:-6px;' class='xlabel ${this.name}'>
										${this.name}
									</span>
									<div class='legendTooltip-container'>
									<div class="tooltipText">${frequencyLegendTooltip}</div>
									<div class="tooltip-pointer"></div>
									</div>`;
						}
					} else if (this.name.toUpperCase().includes('UNIQUES')) {
						return `<i class="fa fa-circle primary-color legend-icons ${this.name}" style="font-size: 29px"></i>
								<span style='margin-left: 10px; position:relative; top:-8px;' class='xlabel ${this.name}'>
									${this.name}</span>
								<div class='legendTooltip-container'>
								<div class="tooltipText">${uniquesLegendTooltip}</div>
								<div class="tooltip-pointer"></div>
								</div>`;
					}
				}
			}
		};
	}

	getGraphDataforEachCampaign(householdObj: any): {} {
		const returnObj = JSON.parse(JSON.stringify(this.getSeriesOptions));
		const colorPaletteArray = [
			this.colorPalette.primaryColor,
			this.colorPalette.secondaryColor,
			this.colorPalette.tertiaryColor
		];
		returnObj.forEach((obj, index) => {
			returnObj[index]['data'] = householdObj[obj.dataSource];
			returnObj[index]['color'] = !obj.color ? colorPaletteArray[obj.index] : this.colorPalette[obj.color];
		});
		return returnObj;
	}

	moveToSelected(index: number): void {
		this.currentIndex = index;
		this.displayIndex = index;
		this.carousel.moveTo(index, false);
		this.campaignCarouselItem = this.campaignsList[this.displayIndex];
		this.campaignCarouselItem.xAxis.labels.step =
			this.campaignCarouselItem.data.length > 0 &&
			this.maxLabelsAllowed > 1 &&
			this.campaignCarouselItem.data.length > this.maxLabelsAllowed &&
			Math.ceil(this.campaignCarouselItem.data.length / this.maxLabelsAllowed) > 1
				? Math.ceil(this.campaignCarouselItem.data.length / this.maxLabelsAllowed)
				: this.campaignCarouselItem?.xAxis?.labels?.step
				? this.campaignCarouselItem.xAxis.labels.step
				: 1;
	}

	prevArrow(): void {
		if (this.campaignsList.length > 1) {
			if (this.displayIndex === 0) {
				this.displayIndex = this.campaignsList.length - 1;
			} else {
				this.displayIndex = this.displayIndex - 1;
			}
			this.moveToSelected(this.displayIndex);
		}
	}

	nextArrow(): void {
		if (this.campaignsList.length > 1) {
			if (this.campaignsList.length - 1 === this.displayIndex) {
				this.displayIndex = 0;
			} else {
				this.displayIndex = this.displayIndex + 1;
			}
			this.moveToSelected(this.displayIndex);
		}
	}

	formatValuesForComma(value: any): string {
		return Number(value).toLocaleString('en-GB');
	}

	initDataFn(key: NguCarouselStore): void {
		this.carouselToken = key.token;
	}

	/* sortCampaignsAsLatestFisrt ::-- Campaigns sorting as Latest campaign first and names ascending */
	sortCampaignsAsLatestFisrt(campaigns: Array<any>) {
		campaigns.sort((a, b) => {
			let aLength = a.data.length;
			let bLength = b.data.length;
			if (aLength > 0 && bLength > 0) {
				return Date.parse(b.data[0].date) - Date.parse(a.data[0].date) == 0
					? a.name < b.name
						? -1
						: a.name > b.name
						? 1
						: 0
					: Date.parse(b.data[0].date) - Date.parse(a.data[0].date);
			} else {
				return aLength == 0 && bLength > 0
					? 1
					: aLength > 0 && bLength == 0
					? -1
					: a.name < b.name
					? -1
					: a.name > b.name
					? 1
					: 0;
			}
		});
	}

	checkCampaignDateBanner(campaignObject: any): boolean {
		if (campaignObject && campaignObject.cmp_start_date) {
			const cmpStartDate = moment(campaignObject.cmp_start_date);
			return cmpStartDate.isBefore(this.minDate);
		}
		return false;
	}
}
